import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/auth.css';

const LOGO_URL = '/woss-publishing-assets/images/woss-publishing-logo-white.svg';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('Please enter your email address.'); return; }
    setLoading(true);
    try {
      await fetch('/api/auth/forgot-password', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ email: email.trim() }),
      });
      setSent(true);
    } catch {
      setError('Unable to reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wp-auth wp-auth--white">
      <main className="wp-auth__main">
        <div className="wp-auth__card wp-auth__card--white">

          <div className="wp-auth__logo-center">
            <Link to="/" aria-label="Woss Publishing">
              <img src={LOGO_URL} alt="Woss Publishing" className="wp-auth__logo wp-auth__logo--white" />
            </Link>
          </div>

          <h1 className="wp-auth__white-heading">FORGOT YOUR PASSWORD?</h1>

          {sent ? (
            <p className="wp-auth__white-sub" style={{ color: 'rgba(0,0,0,0.72)' }}>
              If an account exists for <strong>{email}</strong>, we have sent instructions
              to reset your password. Please check your inbox and spam folder.
            </p>
          ) : (
            <>
              <p className="wp-auth__white-sub">
                Enter your email address and we will send you instructions to reset your password.
              </p>
              {error && <div className="wp-auth__white-error" role="alert">{error}</div>}
              <form className="wp-auth__form" onSubmit={handleSubmit} noValidate>
                <div className="wp-auth__field wp-auth__field--white">
                  <label className="wp-auth__label--white" htmlFor="fp-email">
                    Email address *
                  </label>
                  <input
                    id="fp-email"
                    className="wp-auth__input--white"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(''); }}
                    required
                    aria-required="true"
                  />
                </div>
                <button type="submit" className="wp-auth__btn--white" disabled={loading}>
                  {loading ? 'Sending…' : 'CONTINUE'}
                </button>
              </form>
            </>
          )}

          <div className="wp-auth__white-links">
            <Link to="/auth/login" className="wp-auth__white-link" style={{ textDecoration: 'underline' }}>
              Back to login
            </Link>
          </div>

        </div>
      </main>

      <footer className="wp-auth__footer wp-auth__footer--white">
        &copy; {new Date().getFullYear()} Woss Music Publishing Group LLC.{' '}
        <a href="/legal/terms" className="wp-auth__white-link">Terms of Use</a>
        {' · '}
        <a href="/legal/privacy" className="wp-auth__white-link">Privacy Policy</a>
      </footer>
    </div>
  );
}
